import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, MenuItem, Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tabpanel: {
      background: "#FFFFFF",
  },
  textInput: {
      backgroundColor: "white",
      width: "100%",
      marginBottom: "12px",

      "& input": {
          fontSize: "14px",
      },
  },
  content: {
      "& .ck-editor__editable_inline": {
          minHeight: "200px",
      },
  },
  colLink: {
      textDecoration: "none",
      color: "#306F9D"
  },
  buttonGroup: {
      marginTop: "20px",
      textAlign: "right",
      "& button": {
          color: "#306F9D",
          fontSize: "13px",
          textTransform: "inherit",
      },
  },
  box: {
      padding: 0,
      background: "#ffffff",
      paddingTop: "10px",
      paddingBottom: "10px",
      minHeight: "800px",
  },
  innerBox: {
      background: "#ffffff",
      padding: theme.spacing(3),
      marginBottom: theme.spacing(4),
  },
  button: {
      backgroundColor: "#306F9D",
      textTransform: "capitalize",
      color: "white",
      "&:hover": {
          backgroundColor: "#306F9D",
      },
  },
  pagination: {
      "& .MuiTextField-root": {
          width: "35px",
          minWidth: "auto",
      },
      "& .MuiSelect-root": {
          paddingTop: "3px",
          paddingBottom: "3px",
      },
      "& input": {
          padding: "4px 0 !important",
          marginLeft: "10px",
          marginRight: "10px",
      },
      "& button": {
          background: "white",
          color: "#cccccc",
          border: "1px solid #CCCCCC",
          minWidth: "auto",
          width: "24px",
          height: "24px",
          margin: "4px 0",
          "&.left": {
              borderRadius: "4px 0 0 4px",
              marginLeft: "10px",
          },
          "&.right": {
              borderRadius: " 0 4px 4px 0",
          },
      },
  },
}));

export default function PaginationBarForHandler({
  pageSize,
  setPageSize,
  setData,
  setTotalPages,
  paginationHandler,
  gotoPage,
  pageIndex,
  canPreviousPage,
  previousPage,
  nextPage,
  canNextPage,
  elementCounts,
  statuses,
  status,
}) {
  const classes = useStyles();
  console.log('elementCounts: '+JSON.stringify(elementCounts))
  console.log('statuses: '+JSON.stringify(statuses))
  console.log('status: '+status)

  let theElementCounts;
  if (elementCounts) {
    // all elementCounts keys are case insensitive
    theElementCounts = Object.keys(elementCounts).reduce((acc, key) => {
        acc[key.toLowerCase()] = elementCounts[key];
        return acc;
      }, {});
  } else {
    theElementCounts = { all: 0, active: 0, inactive: 0,}
  }

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setData(
        paginationHandler.setPageSize(Number(e.target.value)).setPageIndex(0).getRows()
    );
    setTotalPages(paginationHandler.getTotalPages());
    gotoPage(0);
    // console.log('paginationHandler.pageIndex: '+paginationHandler.pageIndex)
    // console.log('paginationHandler.noOfRows: '+paginationHandler.getRows().length)
    // console.log('paginationHandler.pageSize: '+paginationHandler.pageSize)
    // console.log('paginationHandler.totalPages: '+paginationHandler.getTotalPages())
  }

  return (
    <div className={classes.pagination}>
      Show rows:{" "}
      <TextField
        id="page-rows"
        select
        value={pageSize}
        onChange={handlePageSizeChange}
        variant="outlined"
        style={{ minWidth: "70px" }}
      >
        {[5, 10, 25, 9999999].map((pageSize) => (
          <MenuItem key={pageSize} value={pageSize}>
            {pageSize === 9999999 ? "All" : pageSize}
          </MenuItem>
        ))}
      </TextField>
      Go to{" "}
      <TextField
          id="pagination-field"
          variant="outlined"
          onChange={(e) => {
              const page = e.target.value
                  ? Number(e.target.value) - 1
                  : 0;
              gotoPage(page);
              setData(
                  paginationHandler.setPageIndex(page).getRows()
              );
          }}
      />
      {pageIndex * pageSize + 1} to{" "}
      {(pageIndex + 1) * pageSize >
          theElementCounts[status?.toLowerCase() || "all"]
          ? theElementCounts[status?.toLowerCase() || "all"]
          : (pageIndex + 1) * pageSize}{" "}
              of {theElementCounts[status?.toLowerCase() || "all"]}
      <Button
          onClick={() => {
              previousPage();
              setData(
                  paginationHandler.setPageIndex(pageIndex - 1).getRows()
              );
          }}
          disabled={!canPreviousPage}
          className="left"
      >
          {"<"}
      </Button>
      <Button
          onClick={() => {
              nextPage();
              setData(
                  paginationHandler.setPageIndex(pageIndex + 1).getRows()
              );
          }}
          disabled={!canNextPage}
          className="right"
      >
          {">"}
      </Button>
    </div>
  );
}
